import * as yup from 'yup'

export const promotionalSchema = yup.object({
	email: yup.string().email('E-mail inválido').required('Campo obrigatório'),
	name: yup.string().required('Campo obrigatório'),
	phone: yup.string().required('Campo obrigatório'),
})
